import React from 'react';
import { Container, Nav, Navbar, Row, Col } from 'react-bootstrap';
import { NavLink, Link } from 'react-router-dom';
import Marquee from "react-fast-marquee";
import { IoLocationOutline } from "react-icons/io5";
import { MdOutlinePhoneAndroid } from "react-icons/md";

const TopAnnouncement = () => {
  return (
    <div className='mark-bg'>
      {/* Desktop Top Bar */}
      <div className='d-lg-block d-none'>
        <Container fluid className='px-4'>
          <Row className='py-2 align-items-center'>
            <Col lg="4" className='d-flex align-items-center gap-3'>
              <div>
                <img src={require('../../assets/images/gpay.png')} className='img-fluid gpay' alt='gpay' />
              </div>
              <div className='top-phone-badge text-white'>
                <span>📞 93421 13123</span>
              </div>
            </Col>
            <Col lg='8' className='text-white'>
              <Marquee pauseOnHover={true} direction="left" speed={45}>
                <span className='top-marquee'>
                  ✨ <strong>Alagar Crackers</strong> | Direct Sivakasi Factory Prices | Flat Wholesale Discounts | WhatsApp: +91 93421 13123 | Delivery Across Tamil Nadu & India | Quality & Eco-friendly Fireworks ✨
                </span>
              </Marquee>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Mobile Quick Action Strip */}
      <div className='d-lg-none d-block py-2 px-3'>
        <Row className='align-items-center justify-content-around text-center g-2'>
          <Col xs="4">
            <a href="https://wa.me/919342113123?text=Hello%20Alagar%20Crackers" target="_blank" rel="noopener noreferrer" className='d-flex flex-column align-items-center text-white'>
              <div className='mob-icon mb-1'>
                <img src={require('../../assets/images/whatsappicon.webp')} className='img-fluid' alt='WhatsApp' />
              </div>
              <span style={{ fontSize: '11px', fontWeight: 600 }}>WhatsApp</span>
            </a>
          </Col>
          <Col xs="4">
            <a href='tel:+919342113123' className='d-flex flex-column align-items-center text-white'>
              <div className='mob-icon mb-1'>
                <img src={require('../../assets/images/callicon.webp')} className='img-fluid' alt='Call' />
              </div>
              <span style={{ fontSize: '11px', fontWeight: 600 }}>Call Now</span>
            </a>
          </Col>
          <Col xs="4">
            <a href='https://maps.app.goo.gl/M1GWLcyX96XHrBqMA' target="_blank" rel="noopener noreferrer" className='d-flex flex-column align-items-center text-white'>
              <div className='mob-icon mb-1'>
                <img src={require('../../assets/images/googlelocation.png')} className='img-fluid' alt='Location' />
              </div>
              <span style={{ fontSize: '11px', fontWeight: 600 }}>Location</span>
            </a>
          </Col>
        </Row>
      </div>
    </div>
  );
};

const BrandHeader = () => {
  return (
    <div className='bg-white py-3 border-bottom d-lg-block d-none'>
      <Container>
        <Row className='align-items-center'>
          <Col lg='4'>
            <div className='d-flex align-items-center'>
              <div className='me-3 p-2 bg-light rounded-circle shadow-sm'>
                <IoLocationOutline size={36} color='#d90429' />
              </div>
              <div>
                <div className='bold text-dark' style={{ fontSize: '15px' }}>Store Address</div>
                <div className='regular text-muted' style={{ fontSize: '13px', lineHeight: 1.4 }}>
                  Alagar Crackers, Sankarankovil Rd,<br />Muthugudi, Rajapalayam - 626117
                </div>
              </div>
            </div>
          </Col>
          <Col lg='4' className='text-center'>
            <Link to="/">
              <div className='logo mx-auto'>
                <img src={require('../../assets/images/storelogo.png')} className='img-fluid' alt='Alagar Crackers Logo' />
              </div>
            </Link>
          </Col>
          <Col lg='4'>
            <div className='d-flex align-items-center justify-content-end'>
              <div className='me-3 p-2 bg-light rounded-circle shadow-sm'>
                <MdOutlinePhoneAndroid size={36} color='#d90429' />
              </div>
              <div>
                <div className='bold text-dark' style={{ fontSize: '15px' }}>Direct Support</div>
                <div className='bold text-danger' style={{ fontSize: '18px' }}>+91 93421 13123</div>
                <div className='regular text-muted' style={{ fontSize: '12px' }}>9:00 AM - 10:00 PM (All Days)</div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const AppBar = () => {
  return (
    <>
      <TopAnnouncement />
      <BrandHeader />
      <Navbar expand="lg" className="navback shadow-sm py-2">
        <Container>
          {/* Mobile brand logo */}
          <Navbar.Brand as={Link} to="/" className='d-lg-none d-flex align-items-center'>
            <img src={require('../../assets/images/storelogo.png')} style={{ maxHeight: '44px' }} alt='Alagar Crackers' />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="main-navbar-nav" className="border-0 shadow-none">
            <span className="navbar-toggler-icon"></span>
          </Navbar.Toggle>

          <Navbar.Collapse id="main-navbar-nav">
            <Nav className="mx-auto text-center align-items-center py-2 py-lg-0">
              <Nav.Link as={NavLink} to="/home">Home</Nav.Link>
              <Nav.Link as={NavLink} to="/about">About Us</Nav.Link>
              <Nav.Link as={NavLink} to="/">Pricelist</Nav.Link>
              <Nav.Link as={NavLink} to="/safetytips">Safety Tips</Nav.Link>
              <Nav.Link as={NavLink} to="/contactus">Contact Us</Nav.Link>
            </Nav>
            <div className='d-none d-lg-block'>
              <Link to="/" className='btn estimate'>
                🔥 Order Crackers
              </Link>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

const AppBarTwo = () => {
  return <AppBar />;
};

const AppBarThree = () => {
  return (
    <>
      <TopAnnouncement />
      <BrandHeader />
      <Navbar expand="lg" className="navback shadow-sm py-2">
        <Container>
          <Navbar.Brand as={Link} to="/" className='d-lg-none d-flex align-items-center'>
            <img src={require('../../assets/images/storelogo.png')} style={{ maxHeight: '44px' }} alt='Alagar Crackers' />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="home-navbar-nav" className="border-0 shadow-none" />

          <Navbar.Collapse id="home-navbar-nav">
            <Nav className="mx-auto text-center align-items-center py-2 py-lg-0">
              <Nav.Link as={NavLink} to="/home">Home</Nav.Link>
              <Nav.Link as={NavLink} to="/about">About Us</Nav.Link>
              <Nav.Link as={NavLink} to="/">Pricelist</Nav.Link>
              <Nav.Link as={NavLink} to="/safetytips">Safety Tips</Nav.Link>
              <Nav.Link as={NavLink} to="/contactus">Contact Us</Nav.Link>
            </Nav>
            <div className='d-none d-lg-block'>
              <Link to="/" className='btn estimate'>
                🔥 Order Crackers
              </Link>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export { AppBar, AppBarTwo, AppBarThree };